/** Numeric client values with the enum names used by GraphQL. */
export interface GraphQLEnumDescriptor {
  readonly name: string
  toGraphQL(value: number): string
  fromGraphQL(value: string): number
}

export function defineGraphQLEnum<const TValues extends Readonly<Record<string, number>>>(
  name: string,
  values: TValues,
  wireNames: Readonly<Record<keyof TValues, string>>
): TValues & GraphQLEnumDescriptor {
  const names = new Map<number, string>()
  const numbers = new Map<string, number>()
  for (const key of Object.keys(values)) {
    const wire = wireNames[key]
    const value = values[key]!
    // Aliased C# members can have the same value; use the first declared spelling.
    if (!names.has(value)) names.set(value, wire)
    numbers.set(wire, value)
  }
  return Object.freeze({
    ...values,
    name,
    toGraphQL(value: number) {
      const result = names.get(value)
      if (result === undefined) throw new Error(`Unknown ${name} value: ${value}.`)
      return result
    },
    fromGraphQL(value: string) {
      const result = numbers.get(value)
      if (result === undefined) throw new Error(`Unknown ${name} GraphQL value: ${value}.`)
      return result
    },
  })
}
